import UtilityHelper from '../utility-helper/utility-helper';

export default class AppDrawerElement extends HTMLElement {
    constructor(){
        super();
        this.opened=false;
        this._contentElement=null;
        this._enableSubmenu=false;
        this._enableSubmenuSubmenu=false;
        this.submenuElement=null;
        this.submenuSubmenuElement=null;
    }

    connectedCallback(){
        this._click=UtilityHelper.clickEvent;
        this._attachModalElement();
        this._setProperties();
        this._setMenuCloseEvent();
        setTimeout(()=>{
            this._setContentElement();
            if(this._enableSubmenu) {
                this._setSubmenuElement();
                this._setSubmenuListeners();
            }
            if(this._enableSubmenuSubmenu) {
                this._setSubmenuSubmenuElement();
                this._setSubmenuSubmenuListeners();
            }
        },500);
    }

    _attachModalElement(){
        var node=document.createElement("div");
        node.classList.add('app-drawer-modal');
        this.appendChild(node);
        this._setDocumentCloseEvent(node);
        this._setSwipeEvent();
    }

    _setProperties(){
        var enableSubmenu=this.getAttribute('enable-submenu');
        if(enableSubmenu) this._enableSubmenu=true;
        var enableSubmenuSubmenu=this.getAttribute('enable-submenu-submenu');
        if(enableSubmenuSubmenu) this._enableSubmenuSubmenu=true;
    }

    _setContentElement(){
        this._contentElement=this.querySelector('app-drawer-content');
        this._contentElement.addEventListener('transitionend',(event)=>{
            if(!this.opened){
                this.classList.remove('content-visible');
                this._contentElement.classList.remove('hide-main-drawer');
            }
        });
    }

    _setSubmenuElement(){
        this.submenuElement=this.querySelector('[data-drawer-submenu]');
    }

    _setSubmenuSubmenuElement(){
        this.submenuSubmenuElement=this.querySelector('[data-drawer-submenu-submenu]');
    }

    _setDocumentCloseEvent(node){
        $(node).on(this._click,(event)=>{
            this.close();
        });
        document.addEventListener('app-layout-close-drawer',this.close.bind(this));
    }

    _setMenuCloseEvent(){
        var $appDrawer=$(this);
        $appDrawer.on(this._click,'[data-drawer-close-button]',this.close.bind(this));
    }

    _setSwipeEvent(){
        $(this).on('swipeleft',(event)=>{
            this.close();
        });
    }

    _setSubmenuListeners(){
        var $appDrawer=$(this);
        $appDrawer.on(this._click,'[data-submenu-back-button]',this._onSubMenuBack.bind(this));
        $appDrawer.on(this._click,'[data-submenu-close-button]',this._onSubMenuClose.bind(this));
        $appDrawer.on(this._click,'a[data-menu-id]',this._onSubMenuRequest.bind(this));
    }

    _setSubmenuSubmenuListeners(){
        var $appDrawer=$(this);
        $appDrawer.on(this._click,'[data-submenu-submenu-back-button]',this._onSubMenuSubMenuBack.bind(this));
        $appDrawer.on(this._click,'[data-submenu-submenu-close-button]',this._onSubMenuSubMenuClose.bind(this));
        $appDrawer.on(this._click,'a[data-submenu-id]',this._onSubMenuSubMenuRequest.bind(this));
    }

    _onSubMenuRequest(event){
        var target=event.target.closest('a[data-menu-id]') || event.target;
        var menuId=target.dataset.menuId;
        // Does this menuId map to a level-3 panel? If so, dispatch to the submenu-submenu handler.
        if(this._enableSubmenuSubmenu && document.querySelector('[data-submenu="' + menuId + '"]')){
            return this._openSubMenuSubMenu(menuId);
        }
        $(this).find('[data-menu]').removeClass('show');
        var menu=document.querySelector('[data-menu="' + menuId + '"]');
        if(menu) menu.classList.add('show');
        this.subMenuOpen=true;
        this._contentElement.classList.add('hide-main-drawer');
        this.submenuElement.classList.remove('hide-menu');
        this.submenuElement.classList.add('show');
        // ensure level 3 is hidden when entering level 2
        if(this.submenuSubmenuElement){
            this.submenuSubmenuElement.classList.remove('show');
        }
    }

    _openSubMenuSubMenu(submenuId){
        $(this).find('[data-submenu]').removeClass('show');
        var menu=document.querySelector('[data-submenu="' + submenuId + '"]');
        if(menu) menu.classList.add('show');
        // hide level 2, show level 3
        this.submenuElement.classList.remove('show');
        this.submenuSubmenuElement.classList.remove('hide-menu');
        this.submenuSubmenuElement.classList.add('show');
    }

    _onSubMenuBack(event){
        this._contentElement.classList.remove('hide-main-drawer');
    }

    _onSubMenuClose(event){
        this.submenuElement.classList.add('hide-menu');
        this.close();
    }

    _onSubMenuSubMenuRequest(event){
        var target=event.target.closest('a[data-submenu-id]') || event.target;
        var submenuId=target.dataset.submenuId;
        this._openSubMenuSubMenu(submenuId);
    }

    _onSubMenuSubMenuBack(event){
        // go back from level 3 to level 2
        this.submenuSubmenuElement.classList.remove('show');
        this.submenuElement.classList.add('show');
    }

    _onSubMenuSubMenuClose(event){
        this.submenuSubmenuElement.classList.add('hide-menu');
        this.submenuElement.classList.add('hide-menu');
        this.close();
    }

    open(){
        if(!this.opened){
            this.opened=true;
            this.classList.add('open','content-visible');
            document.body.classList.add('body-overflow-hidden');
        }
    }

    close(){
        if(this.opened){
            this.opened=false;
            this.classList.remove('open');
            document.body.classList.remove('body-overflow-hidden');
            if(this._enableSubmenu && this.submenuElement){
                this.submenuElement.classList.remove('show');
            }
            if(this._enableSubmenuSubmenu && this.submenuSubmenuElement){
                this.submenuSubmenuElement.classList.remove('show');
            }
        }
    }

    toggle(){
        if(this.opened){
            this.close();
        }else{
            this.open();
        }
    }
}

customElements.define('app-drawer', AppDrawerElement);
